import { useMemo } from "react";
import TeslaBattery from "../../../assets/images/tesla-img.svg";
import FranklinBattery from "../../../assets/images/franklin-img.svg";
import { ListOffer } from "../../../../amplify/backend/function/offerexpstoreFrontApi/ts/public/offerTypes";
import {
  CardBreak,
  CardItem,
  TwoColumnLayout,
  OfferCardBody,
  NonSolarHeader,
  // eslint-disable-next-line import/no-restricted-paths
} from "./OfferCardCommon";
import { formatToOneDecimal } from "utils/formatHelpers";
import {
  PRODUCT_DISPLAY_ORDER,
  STANDALONE_PRODUCT_ID,
  STORAGE_ADDON_PRODUCT_ID,
} from "constants/bundleAndProductIds";

const BATTERY_PRODUCT_IDS = new Set<string>(PRODUCT_DISPLAY_ORDER.BATTERIES);

const BatteryOnlyContent = ({
  offer,
  financing,
  isMobile,
  isTablet,
}: {
  offer: ListOffer;
  financing: string;
  isMobile: boolean;
  isTablet: boolean;
}) => {
  const nonSolarBatteryCount = useMemo(() => {
    return offer.products.filter((item) => {
      return (
        item?.productId === STORAGE_ADDON_PRODUCT_ID ||
        item?.productId === STANDALONE_PRODUCT_ID
      );
    })[0]?.count;
  }, [offer]);

  const accessoryProducts = useMemo(
    () =>
      offer.products.filter(
        (product) =>
          !BATTERY_PRODUCT_IDS.has(product.productId) && product.count > 0
      ),
    [offer.products]
  );

  const getBatteryOnlyHeaderText = (nonSolarBatteryCount: number) => {
    return nonSolarBatteryCount === 1 ? " Battery" : " Batteries";
  };
  return (
    <>
      <NonSolarHeader
        testId="non-solar-battery-header"
        isMobile={isMobile}
        isTablet={isTablet}
        src={
          offer?.batteryManufacturer === "Tesla"
            ? TeslaBattery
            : FranklinBattery
        }
        alt={
          offer.batteryManufacturer === "Tesla"
            ? "Tesla Battery"
            : "Franklin Battery"
        }
        title="Backup Offer"
        count={
          nonSolarBatteryCount + getBatteryOnlyHeaderText(nonSolarBatteryCount)
        }
      />
      <OfferCardBody>
        <TwoColumnLayout>
          {financing && (
            <CardItem title="Financing" value={financing} testId="financing" />
          )}
          {offer?.batteryManufacturer && (
            <CardItem
              title="Battery Type"
              value={offer.batteryManufacturer}
              testId="battery-type"
            />
          )}
          {offer?.usableCapacityKwh && (
            <CardItem
              title="Storage capacity"
              value={formatToOneDecimal(offer.usableCapacityKwh) + " kWh"}
              testId="storage-capacity"
            />
          )}
          {offer?.maxPowerKW && (
            <CardItem
              title="Max Power"
              value={formatToOneDecimal(offer.maxPowerKW) + " kW"}
              testId="max-power"
            />
          )}
          {nonSolarBatteryCount && (
            <CardItem
              title="Batteries"
              value={nonSolarBatteryCount}
              testId="batteries"
            />
          )}
        </TwoColumnLayout>
        {accessoryProducts.length > 0 && (
          <>
            <CardBreak />
            <TwoColumnLayout>
              {accessoryProducts.map((product) => (
                <CardItem
                  key={product.productId}
                  title={product.name}
                  value={product.count}
                  testId={product.name}
                />
              ))}
            </TwoColumnLayout>
          </>
        )}
      </OfferCardBody>
    </>
  );
};

export { BatteryOnlyContent };
